import { render, staticRenderFns } from "./VaTinymceInput.vue?vue&type=template&id=20ae414b&scoped=true&"
import script from "./VaTinymceInput.vue?vue&type=script&lang=js&"
export * from "./VaTinymceInput.vue?vue&type=script&lang=js&"
import style0 from "./VaTinymceInput.vue?vue&type=style&index=0&id=20ae414b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae414b",
  null
  
)

export default component.exports